export default __webpack_public_path__ + "static/media/Hauora-Bold.6d0a2fb0.woff2";